import { createCachedSelector, path, defaultKeySelector } from '@cbridge-utils/redux';
import { authStoreSelector } from '../auth.selector';

export const authUserDataSelector = createCachedSelector(
  [
    path(authStoreSelector).idTokenParsed(),
  ],
  (idTokenParsed): { name: string; email: string } => {
    if (!idTokenParsed) {
      return null;
    }

    return {
      name: idTokenParsed['name'] ?? idTokenParsed['preferred_username'] ?? '',
      email: idTokenParsed['email'],
    };
  },
)({
  keySelector: defaultKeySelector,
});
